export default "__VITE_PUBLIC_ASSET__dfd28f46__"